export default __webpack_public_path__ + "static/gamerize-ed404b4d920960ef34dd46a29d5f043d.svg";